import { render } from "./LogView.vue?vue&type=template&id=3276c7da&scoped=true"
import script from "./LogView.vue?vue&type=script&lang=js"
export * from "./LogView.vue?vue&type=script&lang=js"

import "./LogView.vue?vue&type=style&index=0&id=3276c7da&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3276c7da"]])

export default __exports__